import { gql } from "@apollo/client";

export const CREATE_UNIT = gql`
  mutation CreateUnit($data: UnitInput!) {
    createUnit(data: $data) {
      message
      id
    }
  }
`;

export const UPDATE_UNIT = gql`
  mutation UpdateUnit($data: UnitInput!, $where: UnitWhereInputOne!) {
    updateUnit(data: $data, where: $where) {
      message
    }
  }
`;

export const DELETE_UNIT = gql`
  mutation DeleteUnit($where: UnitWhereInputOne!) {
    deleteUnit(where: $where) {
      message
    }
  }
`;
